import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

export default function LocationSection() {
  return (
    <Box
      id="ubicacion"
      sx={{
        position: "relative",
        backgroundColor: "#000",
        color: "#fff",
        py: { xs: 3, md: 5 },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(128,0,255,0.25) 0%, rgba(0,0,0,0.9)  100%)",
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1000px",
          mx: "auto",
          px: { xs: 3, md: 6 },
          textAlign: "center",
        }}
      >
        <Typography
          component={motion.h2}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          sx={{
            fontWeight: 600,
            color: "#8000FF",
            fontSize: { xs: "1.7rem", md: "2.3rem" },
            mb: { xs: 4, md: 6 },
          }}
        >
          Estamos ubicados en
        </Typography>

        <Box
          sx={{
            position: "relative",
            width: { xs: "90%", sm: "85%", md: "80%" },
            height: { xs: 400, sm: 450, md: 500 },
            mx: "auto",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 0 35px rgba(128,0,255,0.35)",
          }}
        >
          <Box
            component={motion.iframe}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.8027843475677!2d-78.4828675!3d-0.19863119999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91d59bd724b54673%3A0x8c6992c56483f63d!2sDobleDx!5e0!3m2!1ses!2sec!4v1730759469683!5m2!1ses!2sec"
            width="100%"
            height="100%"
            allowFullScreen
            loading="lazy"
            style={{
              border: "none",
              filter: "grayscale(20%) contrast(1.05)",
            }}
            title="Mapa DobleDx"
          />

          <Box
            component={motion.div}
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            sx={{
              position: "absolute",
              bottom: 18,
              right: 18,
              background:
                "linear-gradient(90deg, rgba(58,0,116,0.75) 0%, rgba(128,0,255,0.75) 100%)",
              backdropFilter: "blur(8px)",
              color: "#fff",
              px: 2.5,
              py: 1,
              borderRadius: 2,
              boxShadow: "0 0 15px rgba(128,0,255,0.4)",
              fontWeight: 600,
              fontSize: { xs: "0.9rem", md: "1rem" },
            }}
          >
            DobleDx
          </Box>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          viewport={{ once: true }}
          sx={{
            mt: 6,
            py: 3,
            borderRadius: 3,
            background:
              "linear-gradient(90deg, rgba(58,0,116,0.25) 0%, rgba(128,0,255,0.25) 100%)",
            boxShadow: "0 0 20px rgba(128,0,255,0.2)",
            display: "inline-block",
            px: { xs: 3, md: 6 },
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: { xs: "1rem", md: "1.1rem" },
              color: "#fff",
            }}
          >
            Horario de atención: <strong>Lunes a Viernes</strong>, de <strong>10:00 a 17:00</strong>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
